
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { PasswordInput } from "./PasswordInput";
import { usePasswordUpdate } from "@/hooks/usePasswordUpdate";

interface PasswordChangeFormProps {
  isMobile: boolean;
}

export function PasswordChangeForm({ isMobile }: PasswordChangeFormProps) {
  const { t } = useTranslation();
  const { 
    passwordData, 
    updatePasswordData, 
    isLoading, 
    updatePassword 
  } = usePasswordUpdate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await updatePassword();
  };

  return (
    <Card>
      <CardHeader className="text-left">
        <CardTitle>{t('password_change')}</CardTitle>
      </CardHeader>
      <CardContent className="text-left">
        <form onSubmit={handleSubmit} className="space-y-4">
          <PasswordInput
            id="new-password"
            label={t('new_password')}
            value={passwordData.password}
            onChange={(value) => updatePasswordData('password', value)}
            required
            minLength={8}
            maxLength={25}
          />
          <p className="text-xs text-muted-foreground">
            {t('password_must_be')}
          </p>

          <PasswordInput
            id="confirm-password"
            label={t('confirm_password')}
            value={passwordData.confirmPassword}
            onChange={(value) => updatePasswordData('confirmPassword', value)}
            required
            minLength={8}
            maxLength={25}
          />

          <Button type="submit" disabled={isLoading} className={isMobile ? 'w-full' : ''}>
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {t('update_password')}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
